import functions from "./functions.js";
import tplLoader from "./tpl-loader.js";
import pagination from "./pagination.js";
// import MarkerClusterer from "@google/markerclustererplus";
import Slider from './Slider.js';
import lozad from 'lozad';
// skinuti kasnije novi clusterer sejvao u Tools bookmark

const list = {
    // references
    $form: null,
    form: null,
    filterForm: null,
    noHover: false,
    $filterForm: null,
    $shownItems: null,
    $total: null,
    $body: {},
    $list: null,
    list: null,
    $listWrap: null,
    $map: null,
    map: null,
    infoWindow: null,
    cluster: null,
    lastEvent: null,
    // form params
    params: {},
    defaults: {
        // dateFrom: '',
        // dateTo: '',
        arrivalDateFrom: '',
        destination: '',
        linkedId: '',
        objectTypeId: '',
        unitTypeId: '',
        guests: '0,0',
        personsInObject: '',
        objectGroupId: 6,
        // hasArrival: 4,
        sortBy: 0,
        _page: 1,
        perPage: 10,
        rooms: '',
        //themeId: '',
        tagCategoryId: '',
        distanceBeach: '',
        distanceCenter: '',
        objectId: '',
        hydromassageBathtub: '',
        objectName: '',
        parking: '',
        pool: '',
        pets: '',
        grill: '',
        seaView: '',
        heatedPool: '',
        ac: '',
        satTV: '',
        internet: '',
        disabledPersons: '',
        washingMachine: '',
        bathrooms: '',
        template: '',
        language: functions.getLang(),
        currencyIdTo: functions.getCookie('currencyIdTo') ? functions.getCookie('currencyIdTo') : 1
    },
    mainFields: ['linkedId', 'arrivalDateFrom', 'dates', 'tagCategoryId', 'objectTypeId', 'destination','guests', 'personsInObject', 'sortBy', '_page'],
    secondaryFieldsDesktop: ['dateFrom', 'dateTo', 'dates', 'ms', 'objectTypeId', 'guests', 'personsInObject', 'sortBy', '_page', 'perPage', 'currencyIdTo'],
    // secondaryFieldsMobile: ['objectTypeId', 'personsInObject', 'sortBy', '_page', 'perPage', 'coordinates',  'currencyIdTo'],
    // set by hash change to prevent change event on form fields
    pauseChange: false,
    // hashchange and form fields change are delayed
    changeTimeout: null,
    loading: false,
    // ajax load id
    loadId: 0,
    total: null,
    // for non ajax form to reset page on normal submit
    paginated: false,
    disabledFields: {'pool' : true},
    locations: null,
    pauseDestination: false,
    preselect: null,
    $filterClearTemplate: null,
    $filterClearMobileTemplate: null,
    $formGuide: null,
    $formGuideDefaultPlaceholder: null,
    $formGuideCoordinatesPlaceholder: null,
    //destinationsData: null,

    // methods
    // get URL params and merge with defaults
    getParams() {
        list.params = $.extend({}, list.defaults, functions.getUrlData(true));
        //  Added bcs in from input field name is dates but Render acepts datefrom and dateTo
        if (list.params.dateFrom && list.params.dateTo) list.params.dates = list.params.dateFrom + ' - ' + list.params.dateTo;   
        
        // if (list.params.language == 'cs') list.params.language = 'cz';
        // list.setFiltersCount();
        
    },
    splitDates(params) {
        if(params.dates)
        {
            let val = params.dates.split(' - ');
            params.dateFrom  = val[0];
            params.dateTo    = val[1];
            params.dates = null;
        }
        else
        {
            return;
        }  
    },
    // on form fields change set URL which will trigger load mode
    onChange(e) {
        clearTimeout(list.changeTimeout);
        if ( list.pauseChange ) {
            return;
        }
        // if changed field is date range and not have dateFrom & dateTo prevent url push
        if ( e && e.target.name == 'arrivalDateFrom' ) {
            let val = e.target.value.split(' - ');

            if (val.length == 1) $('.dates-clear').removeClass('d-none');
            
            // when date clear it has one empty element 
            if ( val.length != 2 && val[0] != '') {
                return;
            }
        }
        // for case when coordinates are in url and destination is picked, coordinates need to be cleared, can't have both in url
        if ( e && e.target.name == 'linkedId') {
            // if (e.target.value == list.params.ms) return;
        }
        // 
        if( e && list.mainFields.indexOf(e.target.name) === -1)
        {
            return;
        }
        // not advanced (ajax) search
        if ( !list.$body.length ) {
            return;
        }

        list.noHover = true;
        list.changeTimeout = setTimeout(() => {
            functions.setUrlData(list.getFormData(), list.$body.length);
        }, 300);
    },
    getFormData() {
        let formData = $.extend(
                functions.getFormData(list.$form),
                functions.getFormData(list.$filterForm),
                {
                    _page: list.paginated ? list.params._page : 1,
                    sortBy: list.paginated ? list.params.sortBy : 0
                }
        );
        if (formData.preselectTagCategoryId) delete formData.preselectTagCategoryId;
        // list.paginated = false;
        // // do not send same values as defaults
        // $.map(formData, (val, key) => {
        //     if ( list.defaults[key] == val ) {
        //         delete formData[key];
        //     }
        // });
        return formData;
    },
    init() {
        list.$form = $('.search-form');
        list.$filterForm = $('.filters-form');
        if ( ! list.$form.length ) {
            return;
        }
        
        list.$body = $('.body-listing');

        // register form submit
        list.$form.on('submit', e => {
            e.preventDefault();
            if ( list.$body.length ) {
                list.onChange();
            } else {
                // non ajax form
                let data = $.param(list.getFormData()),
                toHash = list.$form.hasClass('form-hash');
                let href = location.protocol + '//' + location.host + list.$form.attr('action');
                if ( data ) {
                    href += (href.indexOf('?') === -1 ? (toHash ? '#' : '?') : '&');
                }
                href += data;
                list.setLoadingMode();
                // if( list.$body.length ) list.toggleFilters(false);
                location.href = href;
            }
        });

        list.preselect = functions.getFormData(list.$filterForm);
        if (list.preselect.tagCategoryId) list.defaults.tagCategoryId = list.preselect.tagCategoryId

        
        list.form = list.$form[0];
        list.filterForm = list.$filterForm[0] || false;
       
        list.$shownItems = $('.list-shown-items');
        list.$total = $('.list-total');
        
        list.setDisabledFields();
        list.getParams();
        
        let paramsForData = $.extend({}, list.preselect, list.params);

        if (list.params.arrivalDateFrom) $('.dates-clear').removeClass('d-none');
        if (list.params.guests !== list.defaults.guests) $('.guests-clear').removeClass('d-none');

        // if (list.params.ms) $('.ms-clear').removeClass('d-none');
        
        $('.dates-clear').on('click', function(e) {
            $('.dates-clear').addClass('d-none');
        })

        $('[name="guests"]').on('change', e => {
           if ($(e.target).val() !== list.defaults.guests) $('.guests-clear').removeClass('d-none');
        })
        
        $('.guests-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            list.params.guests = list.defaults.guests;
            $('.guests-clear').addClass('d-none');
            $(list.form.guests).val(list.params.guests).trigger('change');
        });
        

        // delete list.params.ms;
        functions.setFormData(list.form, list.params);
        if (list.filterForm) functions.setFormData(list.filterForm, list.params);
        
        //  This is here bcs new destination componenet dosen't open correctly it we don't exit list.js
        //  but first we need to set FORM DATA bcs of preselect destination on landing pages
        // if (!list.$body.length) return;

        list.$body.length && list.find();
        
        list.registerSearchOpenEvents();


        $('.filter-submit').on('click', e => {
            if ( functions.isMobile())
            {
                let data = $.param(list.getFormData()),
                toHash = true;
                let href = location.protocol + '//' + location.host + list.$form.attr('action');
                if ( data ) {
                    href += (href.indexOf('?') === -1 ? (toHash ? '#' : '?') : '&');
                }
                href += data;
                list.setLoadingMode();
                // if( list.$body.length ) list.toggleFilters(false);
                location.href = href;
            }
            
        });

            list.$filterForm.on('change', e => {
                if (! functions.isMobile()) list.onChange();
            });
        
        

        // register hashchange which trigger load
        $(window).on('hashchange', () => {
            list.pauseChange = true;
            clearTimeout(list.changeTimeout);
            list.changeTimeout = setTimeout(() => {
                list.getParams();
                functions.setFormData(list.form, list.params);
                functions.setFormData(list.filterForm, list.params);
                list.find();
                // here or in component config
                list.pauseChange = false;
            }, 100);
        });

        // register sort
        $('[name="sortBy"]').on('change', e => {
            list.params._page = 1;
            list.params.sortBy = $(e.target).val();
            if ( list.$body.length ) {
                functions.setUrlData(list.params, true);
            } else {
                list.paginated = true;
                list.$form.submit();
            }
        });

        // register paginate        
        $(document).on('click', '.pagination a[data-page]', e => {
            e.preventDefault();
            list.paginate(+$(e.currentTarget).attr('data-page'));
        });

        // more filters actions
        // list.$moreFiltersBtns.on('click', list.toggleFilters);
        // list.$moreFiltersContainer.find('.apply-filters').on('click', () => {
        //     list.toggleFilters(false);
        //     if ( list.$body.length ) {
        //         list.onChange();
        //     } else {
        //         list.$form.submit();
        //     }
        // });
        // show list item on map
        if ( list.$list ) {
            list.suppressMapEvents = true;
            list.$list.on('mouseenter', '.show-on-map', e => {
                e.stopPropagation();
                e.preventDefault();
                const $this = $(e.currentTarget);
                const objectId = +$this.attr('data-objectId');
                const marker = list.markers.filter(marker => marker.objectId === objectId)[0];
                // list.map.setCenter(marker.position);
                // list.map.setZoom(15);                
                google.maps.event.trigger(marker, 'click');
            });
        }

        // show map button only after list srolled a bit
        if ( list.$list) {
            let listScrollTimeout = 0;
            list.$listWrap.on('scroll', e => {
                clearTimeout(listScrollTimeout);
                listScrollTimeout = setTimeout(() => list.$body.toggleClass('list-scrolled', list.$listWrap.scrollTop() > 300), 50);
            });
            if ( ! functions.isMobile()) 
            {
                list.$listWrap.on('click', '.btn-show-map', e => {

                    list.$listWrap.animate({ scrollTop: 0 });
                });
            }
        }

    },
    setDisabledFields() {
        let disabledFields = list.$form.attr('data-disabledFields');
        if ( disabledFields ) {
            disabledFields = JSON.parse(disabledFields);
            $.map(disabledFields, (value, name) => {
                if ( list.form[name] ) {
                    list.disabledFields[name] = true;
                    list.defaults[name] = value;
                    list.form[name].disabled = true;
                    if ( name == 'dateFrom' || name == 'dateTo' ) {
                        $(list.form[name]).next().prop('disabled', true);
                    }
                }
            });
        }
    },
    setFiltersCount() {
        let filtersCount = 0;
        $.map(list.params, (val, name) => {
            list.mainFields.indexOf(name) === -1 && (val !== list.defaults[name] || list.disabledFields[name]) && (filtersCount++);
        });
        list.$filtersCount.html(filtersCount || '');
    },
    loadMap() {
        if ( $('.list-map').length ) {
            window.loadGoogleMaps().then(list.initMap);
        }
    },
    initMap() {
        list.$map = $('.list-map');
        list.map = new google.maps.Map(list.$map[0], {
            zoom: 11,
            center: { lat: 45.0805055, lng: 14.5523531 },
            gestureHandling: 'greedy',
            mapTypeControl: false,
            styles: [{
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                    { visibility: 'off' }
                ]
            }]
        });
        // only trigger mapfind when zoomout or dragend, zoomin we already have data
        list.map.addListener('zoom_changed', () => {
            if ( list.suppressMapEvents ) {
                return;
            }
            list.cluster && list.cluster.clearMarkers();
            list.lastEvent = 'zoom';
        });
        list.map.addListener('dragend', () => {
            if ( list.suppressMapEvents ) {
                return;
            }
            list.cluster && list.cluster.clearMarkers();
            list.lastEvent = 'dragend';
        });
        list.map.addListener('bounds_changed', () => {
            if ( list.suppressMapEvents ) {
                setTimeout(() => {
                    list.suppressMapEvents = false;
                });
            }
        });
        list.map.addListener('idle', () => {
            if ( list.suppressMapEvents ) {
                return;
            }
            if ( !list.lastEvent ) {
                return;
            }
            const bounds = list.map.getBounds();
            const sw = bounds.getSouthWest();
            const nw = bounds.getNorthEast();
            list.params._page = 1;
            
            // on drag destination clears
            if(list.params.ms) {
                list.params.ms = '';
            }
            functions.setUrlData(list.params, true);
        });

        // init info window
        list.infoWindow = new google.maps.InfoWindow({
            maxWidth: 200
        });
        list.infoWindow.addListener('domready', () => {
            // init infoWindow slider
            new Slider('#map-details-slider', {
                rubberband: false,
                loop: true,
                arrows: true,
                drag: true,
                slides: {
                    perView: 1
                },
                spacing: 0,
                pager: true,
                duration: 1000
            });
            observer.observe();
        });
    },
    setMarkers() {
        if ( !list.map ) {
            setTimeout(list.setMarkers, 50);
            return;
        }
       // const bounds = new google.maps.LatLngBounds();
        //bounds.extend({ lat: 44.33430909374701, lng: 15.182509562684704 });
        // init each marker
        const bounds = new google.maps.LatLngBounds();
        list.markers = list.locations.map(location => {
            location.lat = +location.lat;
            location.lng = +location.lng;
            bounds.extend({ lat: location.lat, lng: location.lng });
           
            const marker = new google.maps.Marker({
                position: location,
                map: list.map,
                icon: {
                    path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
                    scale: 0.6,
                    fillColor: "#28587F",
                    fillOpacity: 0.7,
                    strokeWeight: 0
                },
            });
            marker.idList = location.idList;
            // marker.objectId = location.objectId;
            marker.addListener('click', () => {
                list.splitDates(list.params);
                const params = {
                    idList: marker.idList,
                    dateFrom: list.params.dateFrom,
                    dateTo: list.params.dateTo,
                    guests: list.params.guests,
                    language: functions.getLang(),
                    map: 'map'
                };
                if ( ! list.noHover)
                {
                    $.get('/services/objectDetails/', params).then(response => {
                        let res = JSON.parse(response);
                        if ( res.status ) {
                            list.infoWindow.setContent(res.html);
                            list.infoWindow.setPosition({lat: marker.getPosition().lat(), lng: marker.getPosition().lng()});
                            list.infoWindow.open(list.map);
                        }
                    });
                }
            });
            return marker;
        });
        //list.map.fitBounds(bounds);
        // init cluster
        // if ( !list.cluster ) {
        //     list.cluster = new MarkerClusterer(list.map, [], {
        //         minimumClusterSize: 10,
        //         maxZoom: 14,
        //         zoomOnClick: false,
        //         styles: [{
        //             url: '/wp-content/uploads/cluster.png',
        //             textSize: 14,
        //             height: 40,
        //             width: 40
        //         }]
        //     });
        //     // force cluster full zoom
        //     list.cluster.addListener('click', function(cluster) {
        //         list.map.setCenter(cluster.center_);
        //         list.map.fitBounds(cluster.getBounds());
        //         // list.map.setZoom(15);
        //     });
        // }

        // list.cluster.clearMarkers();
        // list.cluster.addMarkers(list.markers);
        // if ( !list.lastEvent ) {
        //     list.suppressMapEvents = true;
        //     if ( list.markers.length === 1 ) {
        //         list.map.setCenter(list.markers[0].position);
        //         list.map.setZoom(13);
        //     }
        //     else if ( list.markers.length ) {
        //         list.map.fitBounds(bounds, 0);
        //         //list.cluster.fitMapToMarkers();
        //     }
        //     else if ( list.params.coordinates ) {
        //         let coordinates = list.params.coordinates.split(',');
        //         const bounds = new google.maps.LatLngBounds();
        //         bounds.extend({ lat: +coordinates[0], lng: +coordinates[2] });
        //         bounds.extend({ lat: +coordinates[1], lng: +coordinates[3] });
        //         list.map.fitBounds(bounds, 0);
        //     }
        //     return;
        // }
        list.lastEvent = null;
    },
    setLoadingMode() {
        if ( !list.loading ) {
            list.loading = true;
            if (list.$body.length) {
                if( ! $('.list-map').length && list.total)
                {
                    let offset = $('.search-form').offset().top - 100;

                    if (! list.preselect.tagCategoryId) offset -=2000;
                    window.scrollTo({
                        top: offset,
                        left: 0,
                        behavior: 'instant',
                      });
                }
                list.$body.addClass('loading');
                list.$body.prepend(tplLoader).scrollTop(0);
                list.$listWrap.scrollTop(0); // mobile
                list.$list.scrollTop(0);
                list.infoWindow && list.infoWindow.close();
            } else {
                list.$form
                    .find('.form-submit').prop('disabled', true)
                    .find('i').addClass('fa-spinner fa-spin fa-lg');
            }
        }
    },
    unsetLoadingMode() {
        if ( list.loading ) {
            list.loading = false;
            list.$body.removeClass('loading').find('.list-loader').remove();
        }
    },
    find() {
        // init list
        if ( !list.$list ) {
            list.$list = $('.list');
            list.list = list.$list[0];
            list.$listWrap = list.$list.closest('.list-wrap');
        }
        list.setLoadingMode();
        let ajaxId = ++list.loadId;
        if ($('.list-map').length) list.mapFind(ajaxId);
        let submitParams = $.extend({}, list.params);
        // so after any map event destinaton search filed clears
        this.splitDates(submitParams);

        // if we have objectName we only need object name, guests and period (from - to)
        $.get('/services/list/', submitParams).then(response => {
            if ( ajaxId !== list.loadId ) {
                return;
            }
            response = JSON.parse(response);
            list.total = response.total;
            list.$list[0].innerHTML = response.html + pagination({
                currentPage: list.params._page,
                total: list.total,
                perPage: list.params.perPage
            });
            //functions.initCompare();
           // list.setResultsText();
            list.noHover = false;
            list.domInits();
            list.unsetLoadingMode();
        });
    },
    setResultsText() {
        let maxResults = list.params._page * 10;
        list.$shownItems.html(
            (maxResults - 9) +
            ' - ' +
            (maxResults > list.total ? list.total : maxResults)
        );
        list.$total.html(list.total);
    },
    domInits() {
        const observerVillas = lozad('.card-list', {
            rootMargin: '100px 100px',
            loaded: el => {
                let catalogueSliderCrads = [];
                $(el).find('[id^=catalogue-slider-cards]').each((i, elem) => {
                    catalogueSliderCrads[i] = new Slider('#' + $(elem).attr('id'), {
                        rubberband: false,
                        loop: true,
                        arrows: true,
                        pager: true,
                        slides: {
                            perView: 1,
                            spacing: 0,
                        },
                        autoplay: 0,
                        drag: true,
                        pauseOnHover: false,
                        autoLoadSlides: 2
                    });
                });
                    $(el).triggerHandler('lozadLoaded');
                }
            });
        observerVillas.observe();
        


        let $dropdown = $(".dropdown-sort-by");
        $dropdown.find('.dropdown-item').on('click', function (e) {
            e.preventDefault();
            list.params._page = 1;
            list.params.sortBy = $(e.currentTarget).attr('href');
            if ( list.$body.length ) {
                functions.setUrlData(list.params, true);
            } else {
                list.paginated = true;
                list.$form.submit();
            }
        });

        // premješteno ovdje jer filter bar ima clear-filters, a on se inicijalizira nakon dohvaćanja liste
        $('.clear-filters').on('click', e => {
            let changed = false;
            let formData = {};
            let filters = functions.isMobile() ? list.secondaryFieldsMobile : list.secondaryFieldsDesktop;
            $.map(list.params, (value, key) => {
                if ( filters.indexOf(key) === -1 ) {
                    if(functions.isMobile() && ['guests', 'ms', 'dates'].indexOf(key) != -1)  return;
                    
                    if ( list.params[key] && list.params[key] != list.defaults[key] ) {
                        changed = true;
                    }
                    formData[key] = list.defaults[key];
                }
            });
            functions.setFormData(list.form, formData);
            functions.setFormData(list.filterForm, formData);
            // list.toggleFilters(false);
            if ( changed ) {
                if ( ! e.target.classList.contains('clear-filters-mobile') ) {
                    list.onChange();
                }
                if ( !list.$body.length ) {
                    list.$form.submit();
                }
            }
        });

        if (list.params.sortBy) {
            let text = $dropdown.find(".dropdown-item[href='"+list.params.sortBy+"']").html();
            $dropdown.find(".sort-text").html(text);
        }

        observer.observe();
    },
    mapFind(ajaxId) {
        let params = Object.assign({}, list.params);
        if ( list.lastEvent ) {
            const bounds = list.map.getBounds();
            const sw = bounds.getSouthWest();
            const nw = bounds.getNorthEast();
        } else {
            if ( !params.ms ) {
                //params.destination = '8';
            }
        }
        this.splitDates(submitParams);
        // if we have objectName we only need object name, guests and period (from - to)
        if(submitParams.objectName)  
        {
            submitParams = $.extend({}, {
                objectName: submitParams.objectName, 
                guests: submitParams.guests, 
                dateFrom: submitParams.dateFrom,
                dateTo: submitParams.dateTo,
                language: submitParams.language,
                perPage: submitParams.perPage,
                _page: submitParams._page,
            })
        }
        $.get('/services/map/', submitParams).then(response => {
            if ( ajaxId !== list.loadId ) {
                return;
            }
            list.locations = JSON.parse(response);
            list.setMarkers();
        });
    },
    paginate(page) {
        if ( page != list.params._page ) {
            list.params._page = page;
        }
        if ( list.$body.length ) {
            functions.setUrlData(list.params, list.$body.length);
        } else {
            list.paginated = true;
            list.$form.submit();
        }
    },
    registerSearchOpenEvents()
    {
        let home = list.$form.hasClass('form-hash');
        if (home)
        {
            $('#select2-dest').on('select2:select', function (e) {
                $('.datepicker-range')[0]._flatpickr.open();
    
                $('.datepicker-range')[0]._flatpickr.config.onClose.push(function() {
                    $('.simple-guests').dropdown('toggle');
                })
              });
        }
        else 
        {
            $('#select2-dest').on('select2:select', function (e) {
                if (! list.params.dates) $('.datepicker-range')[0]._flatpickr.open();
            });
        }
    },

    dateForFilters()
    {
        let val = list.params.dates.split(' - ');
        let dateFrom = new Date(val[0]);
        let dateTo = new Date(val[1]);
        dateFrom = dateFrom.getDate() + '/' + (dateFrom.getMonth() + 1);
        dateTo = dateTo.getDate() + '/' + (dateTo.getMonth() + 1);
        return dateFrom + ' - ' + dateTo;
    },

    guestsForFilters()
    {
        let val = [];
        val = list.defaults.guests.split(',');
        if(list.params.guests) {val = []; val = list.params.guests.split(',');}
        let guests = parseInt(val[0]) + parseInt(val[1]);
        return ': ' +  guests;
    }
};

$(() => {
    list.init();
    list.loadMap();
});